import { Component, OnInit, ChangeDetectorRef, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { DialogOverviewExampleDialogComponent } from "../../dialog-overview-example-dialog/dialog-overview-example-dialog.component";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { ChangeUsersService } from "../../../app/services/change-users.service";
import { MenuService } from "../../../app/menu.service";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { FormControl, FormGroup } from "@angular/forms";
import  moment from "moment-timezone";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-audit",
  templateUrl: "./audit.component.html",
  styleUrls: ["./audit.component.scss"],
  standalone: true,
  imports: [MatToolbarModule,CommonModule,FormsModule,MatFormFieldModule,MatDatepickerModule,MatInputModule,MatNativeDateModule,ReactiveFormsModule,MatButtonModule]
})
export class AuditComponent implements OnInit {
  public middlewareServiceUrl = BaseUrlConstantsService.BASE_MIDDLEWARE_SELF;
  public reportServiceUrl = BaseUrlConstantsService.BASE_ASSET_REPORT_URL;
  public report_generate = BaseUrlConstantsService.Generate_new_url;
  // public service: BackendApiService;
  public myDate: Date;
  selectedReportDetails: any = null;
  public today: any;
  public allDevices: any = [];
  public clientId: any;
  public siteList: any = [];
  public presignAudit: string;
  public groupList: any = [];
  public devices: any = [];
  public searchText: any;
  public allDeviceSecondArray: any = [];
  public pid: boolean;
  public showList: boolean;
  public emptyMsg: boolean;
  public emptyMsgSHOW: string;
  public checked = false;
  public assetList: any = [];
  public assets: any = [];
  public term: any;
  public showFilter = false;
  public selectValueArr = [];
  public assetsAll: any = [];
  public arrListAssets: any;
  public gridLayoutOn = true;
  public listLayoutOn: boolean;
  public chartBoxVisibility: boolean;
  public sensorDataArr = [];
  filtersApplied = false; // Julio
  public selectedSite: string = "All Sites";
  public breadcrumbsArray: any = [
    {
      page_ref: "/audit",
      page_title: "Audit Reports",
    },
  ];
  public filterList = [
    {
      title: "All Assets",
      value: "1",
    },
    {
      title: "ERROR",
      value: "1",
    },
    {
      title: "HEALTHY",
      value: "1",
    },
    {
      title: "UNASSOCIATED",
      value: "1",
    },
    {
      title: "OFFLINE",
      value: "1",
    },
  ];
  public showEmptyError = "Fetching reports, please wait..";
  public sitesList: any = [];
  public check = 0;
  public objBread: any;
  public pageName: string;
  public _lastUpdate: any;
  disablePlantButton: boolean;
  public isDisabled: boolean;
  public userRoll: any;
  public _timeOut: any;
  public hideItemsFromAssets = false;
  public adminClinetLogin: boolean;
  public eventHoverOnCard: any;
  public intervalVar: any;
  public devicedata: any;
  public _driveTemps: any = [];
  public _rmsAccels: any = [];
  public mouseenter: boolean;
  public hidePopover: boolean;
  public mouseleave: boolean;
  public _greenRmsIcon: boolean = false;
  public _yellowRmsIcon: boolean = false;
  public _redRmsIcon: boolean = false;
  public shouldShow: boolean;
  public checkClass: string;
  public company_name: string;
  public userID: any;
  public reportDataArr: any = [];
  macAdd: string = "";
  clientName: string = "";
  sNumber: string = "";
  site: string = "";
  application: string = "";

  termName: any;
  searchedKey: string = "";
  page = 1;
  count = 0;
  tableSize = 10;

  selectedUserId: any = null;
  // tableSizes = [3, 6, 9, 12];

  public isAllSelected: boolean;

  public paginatedReportDataArr: any = []; // Data for current page
  @ViewChild(MatPaginator) paginator: MatPaginator;
  currentPage: number = 1;
  itemsPerPage: number = 10;

  // Defining the date picker range form group
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  constructor(
    public router: Router,
    public menuService: MenuService,
    public activeRoute: ActivatedRoute,
    private changeService: ChangeUsersService,
    public dialog: MatDialog,
    public service: BackendApiService,
    private cdr: ChangeDetectorRef // Add ChangeDetectorRef here
  ) {
    this.userID = localStorage.getItem("user_id");
    this.company_name = localStorage.getItem("company_name");
    this.utcTime();
    this.userRoll = localStorage.getItem("role");
  }

  utcTime() {
    setInterval(() => {
      const date = new Date().getHours();
      const houre = new Date().getMinutes();
      const second = new Date().getSeconds();
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  ngOnInit() {
    this.getallDevices("", "", "", "", "");
    this.userRoll = localStorage.getItem("role");
  }

  gridLayout() {
    this.gridLayoutOn = false;
    this.listLayoutOn = true;
  }

  listLayout() {
    this.gridLayoutOn = true;
    this.listLayoutOn = false;
  }

  viewAuditReport(report: any) {
    console.log(typeof report);
    let newReport = JSON.parse(report);
    console.log(newReport);
    let { bearing_radio, ...others } = newReport;

    if (bearing_radio === "on") {
      newReport.bearing_radio = "ON";
    } else if (bearing_radio === "off") {
      newReport.bearing_radio = "Sleeve Bearing is Selected";
    }
    this.selectedReportDetails = JSON.stringify(newReport);

    if (report !== undefined) {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
        width: "700px",
        maxWidth: "815vw",
        height: "500px",
        data: {
          type: "auditDialogBox",
          asset_obj: JSON.stringify(newReport),
        },
      });
    }
  }

  onTableDataChange(event) {
    this.page = event;
    this.getallDevices(
      this.macAdd,
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }

  async getallDevices(mac_address, client, serial_number, site, application) {
    this.filtersApplied =
      mac_address || client || serial_number || site || application
        ? true
        : false;
    const userRole = localStorage.getItem("role");
    const belongToParam =
      Math.floor(Math.random() * 90 + 10) +
      this.userID +
      Math.floor(Math.random() * 9000 + 1000);

    try {
      const response = await this.service.getData(
        `${this.middlewareServiceUrl}v1/audit/trail?belong_to=${belongToParam}&mac_address=${mac_address}&client=${client}&serial_number=${serial_number}&role=${userRole}&site=${site}&application=${application}`
      );
      const responseBody = JSON.parse(JSON.stringify(response));

      if (
        responseBody.data &&
        responseBody.data.body &&
        responseBody.data.body.items
      ) {
        this.allDeviceSecondArray = responseBody.data.body.items.map((val) => {
          let DateUtc = moment.utc(val.created_at);
          let localDate = DateUtc.local();
          let time_recorded = new ConvertDatetimePipe().convertDateTime(
            localDate
          );
          val.created_at = time_recorded;
          return val;
        });
        this.reportDataArr = this.allDeviceSecondArray;
        this.updatePaginatedData(); // Add this line
        this.showEmptyError = "";
      } else {
        this.showEmptyError = "No Reports Available!";
        this.reportDataArr = [];
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      this.showEmptyError = "Error fetching data";
    }
  }

  private updatePaginatedData() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedReportDataArr = this.reportDataArr.slice(
      startIndex,
      endIndex
    );
    this.cdr.detectChanges(); // Update the view
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize;
    this.updatePaginatedData();
  }

  searchData(ev) {
    const term = ev;
    this.macAdd = ev;
    //this.clientName = "";
    //this.sNumber = "";
    this.getallDevices(
      this.macAdd,
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }

  searchbyname(ev) {
    const term = ev;
    //this.macAdd = "";
    this.clientName = ev;
    //this.sNumber = "";
    this.getallDevices(
      this.macAdd,
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }

  searchbySerialNo(ev) {
    const term = ev;
    //this.macAdd = "";
    //this.clientName = "";
    this.sNumber = ev;
    this.getallDevices(
      this.macAdd,
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }
  searchbySite(ev) {
    const term = ev;
    //this.macAdd = "";
    //this.clientName = "";
    //this.sNumber = "";
    this.site = ev;
    this.getallDevices(
      this.macAdd,
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }
  searchbyApplication(ev) {
    const term = ev;
    //this.macAdd = "";
    //this.clientName = "";
    //this.sNumber = "";
    //this.site=""
    this.application = ev;
    this.getallDevices(
      this.macAdd,
      this.clientName,
      this.sNumber,
      this.site,
      this.application
    );
  }

  filterByDateRange(start, end) {
    return this.allDeviceSecondArray.filter((report) => {
      const date = new Date(report.created_at);
      return date >= start && date <= end;
    });
  }

  async onDateRangeChange(start: Date, end: Date) {
    // Formatting start and end dates
    const formattedStartDate = moment(start)
      .set({ hour: 0, minute: 0, second: 0 })
      .format("YYYY-MM-DD HH:mm:ss");

    var formattedEndDate = moment(end == null ? new Date() : end)
      .set({ hour: 23, minute: 59, second: 59 })
      .format("YYYY-MM-DD HH:mm:ss");
    console.log("Date Range:", formattedStartDate, formattedEndDate);
    // formattedEndDate == "Invalid%20date" ? "" : formattedEndDate;
    if (formattedEndDate == "Invalid date") {
      formattedEndDate = "";
    }
    const userRole = localStorage.getItem("role");
    const belongToParam =
      Math.floor(Math.random() * 90 + 10) +
      this.userID +
      Math.floor(Math.random() * 9000 + 1000);

    const apiUrl = `${this.middlewareServiceUrl}v1/audit/trail?&belong_to=${belongToParam}&mac_address=${this.macAdd}&client=${this.clientName}&serial_number=${this.sNumber}&role=${userRole}&site=${this.site}&application=${this.application}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;

    // Set filtersApplied to true as we are applying a date filter
    this.filtersApplied = true;

    try {
      const response = await this.service.getData(apiUrl);
      console.log("API Response:", response);

      const responseBody = JSON.parse(JSON.stringify(response));
      if (
        responseBody.data &&
        responseBody.data.body &&
        responseBody.data.body.items.length > 0
      ) {
        this.reportDataArr = responseBody.data.body.items.map((val) => {
          let DateUtc = moment.utc(val.created_at);
          let localDate = DateUtc.local();
          let time_recorded = new ConvertDatetimePipe().convertDateTime(
            localDate
          );
          val.created_at = time_recorded;
          return val;
        });

        this.updatePaginatedData(); // Update the paginated data
        this.showEmptyError = "";
      } else {
        // Set an appropriate message when there are no records after filtering
        this.showEmptyError = "No records available for this filter criteria";
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      this.showEmptyError = "Error fetching data";
    }
  }

  clearFilters() {
    // Clear the date range form controls
    this.range.controls["start"].setValue(null);
    this.range.controls["end"].setValue(null);

    // Reset all other filter terms
    this.macAdd = "";
    this.clientName = "";
    this.sNumber = "";
    this.site = "";
    this.application = "";

    // Reset the page number to 1
    this.page = 1;
    this.filtersApplied = false;

    // Fetch all reports without any filters on the first page
    this.getallDevices("", "", "", "", "").then(() => {
      if (this.reportDataArr.length === 0) {
        this.showEmptyError = "No Reports Available!";
      }
    });
  }

  async viewAuditReports() {
    const belongToParam =
      Math.floor(Math.random() * 90 + 10) +
      this.userID +
      Math.floor(Math.random() * 9000 + 1000);

    // Define the URL for downloading the audit report
    const downloadReportEndpoint = `${this.reportServiceUrl}audit-reports-download`;

    // Format the start and end dates with specific times
    const formattedStartDate = this.range.value.start
      ? moment(this.range.value.start)
          .set({ hour: 0, minute: 0, second: 0 })
          .format("YYYY-MM-DD HH:mm:ss")
      : "";

    const formattedEndDate = this.range.value.end
      ? moment(this.range.value.end)
          .set({ hour: 23, minute: 59, second: 59 })
          .format("YYYY-MM-DD HH:mm:ss")
      : "";

    // Construct the query string
    const queryParams =
      `?role=${this.userRoll}` +
      `&belong_to=${encodeURIComponent(belongToParam)}` +
      `&mac_address=${encodeURIComponent(this.macAdd)}` +
      `&client=${encodeURIComponent(this.clientName)}` +
      `&serial_number=${encodeURIComponent(this.sNumber)}` +
      `&site=${encodeURIComponent(this.site)}` +
      `&application=${encodeURIComponent(this.application)}` +
      `&startDate=${encodeURIComponent(formattedStartDate)}` +
      `&endDate=${encodeURIComponent(formattedEndDate)}`;

    try {
      const response = await fetch(`${downloadReportEndpoint}?${queryParams}`);
      const data = await response.json();

      if (data.status === 200 && data.key) {
        this.viewAReport(data.key);
        console.log(data.key, "keyPresigned");
      } else {
        console.error("Error downloading audit report:", data.message);
      }
    } catch (error) {
      console.error("Error downloading audit report:", error);
    }
  }

  viewAReport(url) {
    let body: any = {
      key: url,
    };
    this.service
      .postAssetReport(this.report_generate + "/" + "pre-signed-url", body)
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).status == "success") {
          if (JSON.parse(JSON.stringify(res)).body != "") {
            let report_url = JSON.parse(JSON.stringify(res)).body;
            window.open(report_url, "_blank");
          } else {
            this.service.showError("Something went wrong");
          }
        } else {
          this.service.showError("Something went wrong");
        }
      });
  }
}
